// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Fetch from "../../../../../node_modules/bs-fetch/src/Fetch.bs.js";
import * as React from "react";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_array from "../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Js_promise from "../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as OptionUtils from "../../../shared/utils/OptionUtils.bs.js";
import * as $$Notification from "../../../shared/Notification.bs.js";
import * as AuthenticityToken from "../../../shared/utils/AuthenticityToken.bs.js";
import * as CoursesCurriculum__ModuleFeedbackData from "../types/CoursesCurriculum__ModuleFeedbackData.bs.js";

function str(prim) {
  return prim;
}

function initialRating(value) {
  return OptionUtils.mapWithDefault((function (rating) {
                return rating;
              }), 0, value);
}

function ratingButton(rating, selected, setSelected) {
  return React.createElement("button", {
              key: String(rating),
              "aria-label": String(rating),
              className: "h-10 w-10 rounded border text-sm font-semibold transition " + (
                rating === selected ? "bg-primary-500 border-primary-500 text-white" : "bg-white border-gray-300 text-gray-700 hover:border-primary-500"
              ),
              type: "button",
              onClick: (function (param) {
                  Curry._1(setSelected, (function (param) {
                          return rating;
                        }));
                })
            }, String(rating));
}

function ratingField(question, selected, setSelected) {
  return React.createElement("fieldset", {
              className: "mt-6"
            }, React.createElement("legend", {
                  className: "font-semibold text-gray-900"
                }, question), React.createElement("div", {
                  className: "flex flex-wrap gap-2 mt-3"
                }, Js_array.map((function (rating) {
                        return ratingButton(rating, selected, setSelected);
                      }), $$Array.init(10, (function (index) {
                            return index + 1 | 0;
                          })))), React.createElement("div", {
                  className: "flex justify-between text-xs text-gray-500 mt-1 max-w-[28rem]"
                }, React.createElement("span", undefined, "1"), React.createElement("span", undefined, "10")));
}

function CoursesCurriculum__ModuleFeedback(Props) {
  var targetId = Props.targetId;
  var feedback = Props.feedback;
  var questions = CoursesCurriculum__ModuleFeedbackData.questions(feedback);
  var labels = CoursesCurriculum__ModuleFeedbackData.labels(feedback);
  var match = React.useState(function () {
        var value = CoursesCurriculum__ModuleFeedbackData.usefulness(feedback);
        return OptionUtils.mapWithDefault((function (rating) {
                      return rating;
                    }), 0, value);
      });
  var usefulness = match[0];
  var match$1 = React.useState(function () {
        var value = CoursesCurriculum__ModuleFeedbackData.aiInterference(feedback);
        return OptionUtils.mapWithDefault((function (rating) {
                      return rating;
                    }), 0, value);
      });
  var aiInterference = match$1[0];
  var match$2 = React.useState(function () {
        var value = CoursesCurriculum__ModuleFeedbackData.contentQuality(feedback);
        return OptionUtils.mapWithDefault((function (rating) {
                      return rating;
                    }), 0, value);
      });
  var contentQuality = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setSaving = match$3[1];
  var match$4 = React.useState(function () {
        return CoursesCurriculum__ModuleFeedbackData.submitted(feedback);
      });
  var setSaved = match$4[1];
  var save = function ($$event) {
    $$event.preventDefault();
    Curry._1(setSaving, (function (param) {
            return true;
          }));
    var payload = Js_dict.fromArray([
          [
            "usefulness",
            usefulness
          ],
          [
            "ai_interference",
            aiInterference
          ],
          [
            "content_quality",
            contentQuality
          ]
        ]);
    Js_promise.then_((function (response) {
            Curry._1(setSaving, (function (param) {
                    return false;
                  }));
            if (response.ok) {
              Curry._1(setSaved, (function (param) {
                      return true;
                    }));
              $$Notification.success("", labels.saved);
            } else {
              $$Notification.error("", labels.error);
            }
            return Promise.resolve(undefined);
          }), fetch("/targets/" + targetId + "/module_feedback", Fetch.RequestInit.make(/* Post */2, [
                    [
                      "X-CSRF-Token",
                      AuthenticityToken.fromHead(undefined)
                    ],
                    [
                      "Content-Type",
                      "application/json"
                    ]
                  ], Caml_option.some(JSON.stringify(payload)), undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined)));
  };
  return React.createElement("section", {
              className: "mt-8 mb-12 rounded-lg border border-gray-200 bg-gray-50 p-5 md:p-7"
            }, React.createElement("h3", {
                  className: "text-xl font-semibold"
                }, labels.title), ratingField(questions.usefulness, usefulness, match[1]), ratingField(questions.aiInterference, aiInterference, match$1[1]), ratingField(questions.contentQuality, contentQuality, match$2[1]), React.createElement("button", {
                  className: "btn btn-primary mt-6",
                  disabled: match$3[0] || usefulness === 0 || aiInterference === 0 || contentQuality === 0,
                  onClick: save
                }, match$4[0] ? labels.update : labels.submit));
}

var Feedback;

var make = CoursesCurriculum__ModuleFeedback;

export {
  Feedback ,
  str ,
  initialRating ,
  ratingButton ,
  ratingField ,
  make ,
}
/* react Not a pure module */
